export default __webpack_public_path__ + "static/DSC_0082-5b52e556280482a814098488fdf36f2f.jpg";